import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { showToast } from 'actions/admin/auth';
import { getGlobalSchoolUtils, getGlobalCurrentBatchUtils } from 'utils/commonFunc';
import { useTransportData, indexBy } from '../useTransportData';
import TransportReportsView from './TransportReportsView';

// The "Transport" tab of Reports. Admin only (the Reports page only offers the tab to the admin role). It loads the
// same transport data as the Transport page and hands it to the reports.
const TransportReportPage = () => {
  const dispatch = useDispatch();
  const loggedUserToken = useSelector(state => state.auth.loggedUserToken);
  const schoolId = getGlobalSchoolUtils()?.schoolId;
  const { batchId } = getGlobalCurrentBatchUtils();
  const showWarning = (message, type) => dispatch(showToast(message, type));
  const { data, isLoading } = useTransportData({
    schoolId,
    batchId,
    token: loggedUserToken,
    onError: message => showWarning(message, 'error'),
  });

  if (!schoolId) {
    return <div style={{ textAlign: 'center', color: '#9a9a9a', padding: 40 }}>Please select a school.</div>;
  }
  return (
    <TransportReportsView
      schoolId={schoolId}
      batchId={batchId}
      loggedUserToken={loggedUserToken}
      showWarning={showWarning}
      isLoading={isLoading}
      buses={data.buses}
      drivers={data.drivers}
      routes={data.routes}
      areasByRoute={data.areasByRoute}
      studentsByRoute={data.studentsByRoute}
      assignments={data.assignments}
      routesById={indexBy(data.routes, 'transportFeeStructId')}
      busesById={indexBy(data.buses, 'busId')}
      driversById={indexBy(data.drivers, 'employeeId')}
    />
  );
};

export default TransportReportPage;
